import Tooltip from "@material-ui/core/Tooltip";
import React from "react";

const RemovableArea = (props) => {
  const { children, style, ...restProps } = props;

  const getRemovableTarget = (e) => {
    let target = e.target;
    while (!target.dataset.removable || !target.parentNode)
      target = target.parentNode;
    return target;
  }

  const changeBackground = (e) => {
    const target = getRemovableTarget(e);
    target.style.opacity = 0.2;
  };

  const rollbackBackground = (e) => {
    if (props.removed === 'true')
      return;
    const target = getRemovableTarget(e);
    target.style.opacity = 1;
  };

  const markRemovedArea = (e) => {
    const target = getRemovableTarget(e);
    typeof props.onClick === 'function' && props.onClick(target.id);
  };

  return (
    <Tooltip
      title="Left mouse click to mark / unmark as removed area"
      arrow
      placement="top"
    >
      <div
        {...restProps}
        style={{
          ...style,
          display: 'flex',
          cursor: 'pointer',
          opacity: props.removed === 'true' ? 0.2 : 1
        }}
        onMouseOver={changeBackground}
        onMouseOut={rollbackBackground}
        onClick={markRemovedArea}
      >
        {children}
      </div>
    </Tooltip>
  );
};

export default RemovableArea;